export class PendingIntegeration {
  selectedDate: string;
  selectedPeriodType: string;
  selectedFillingStatus: string;
  specialCases: Table_Pcs[]
  earlyAdoption: Table_Pcs[];
  integrationStatus: Table_Pcs[];
}
export interface Table_Pcs {
  standardSourceId: string
  standardSourcePubId: string
  supbtopic: string
  topic: string
  section: string
  paragraph: string
  transitionGuidanceParagraphTopicId: string
  transitionGuidanceParagraphPubId: string
  standardsource: string
  transistionguidance: string;
  id: string;
  date: Date;
  yesOrNo: number
  title: string;
  body: string;
  filingStatus: string;
  periodType: string
  standsourcepdffileName: string
}
//export interface TablePCS {
//  standardSourceId: string
//  standardSourcePubId: string
//  supbtopic: string
//  topic: string
//  section: string
//  paragraph: string
//  transitionGuidanceParagraphId: string
//  transitionGuidanceParagraphPubId: string
//  standardsource: string
//  transistionguidance: string;
//  id: string;
//  type: string;
//  Date: Date;
//  yesOrNo: number
//  title: string;
//  body: string;
//  filingStatus: string;
//  periodType: string

//}
export class PcsFilterCriteria {
  Date: Date;
  filingStatus: string;
  periodType: string;
}
export class PcsFilterCriteriaforHighlight {

  pageId: string;
  publicationId: string;
}
